<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="index">
        <div class="block">
          <el-carousel
            height="800px"
            :autoplay="false"
            direction="vertical"
            :initial-index="number"
            ref="changeCard"
          >
            <el-carousel-item v-for="item in 9" :key="item" name="item">
              <div class="container">
                <div class="left">
                  <img
                    v-if="item == 1"
                    class="left1"
                    src="../../static/images/solutionLeft.png"
                  />
                  <div v-if="item == 2" class="left2">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText3.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText2.png"
                    />
                    <div class="rightText">
                      综合交通管理平台聚焦于交通运行监测调度中心（TOCC）业务，整合城市路网、公共交通、城际交通，城市静态交通数据建立城市交通数据中心，利用大数据赋能交通管理，以交通大数据蕴藏的深度关联分析和人工智能为核心，实时感知城市交通运行态势，同时结合监管需求建立量化多维的交通运行评价指标体系。
                    </div>
                  </div>
                  <div v-if="item == 3" class="left3">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText5.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText4.png"
                    />
                    <div class="rightText">
                      对接高速公路各类感知设备及信息化系统，汇聚高速公路各类数据资源，利用云计算、大数据等现代化信息技术，搭建承载数据资产的大数据平台，基于多源异质异构数据处理技术，形成高速运营状况全时空多维分布“一张图”，对高速运营及安全情况进行实时监测和告警，及时启动应急预案，远程指挥调度，使高速公路管理更科学、指挥响应更迅速、交通事件感知更及时。
                    </div>
                  </div>
                  <div v-if="item == 4" class="left4">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText6.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText7.png"
                    />
                    <div class="rightText">
                      北斗“天枢”公共交通智慧安全立体防控平台是全国首例公共交通智能安防平台，已落地深圳、广州、苏州、无锡等地。平台建成集指挥调度、侦查研判、立体防控、警务管理等为一体的主动安全管理闭环，实现“情-指-勤-行-督”的一体化融合，致力于让公共交通更安全。
                    </div>
                  </div>
                  <div v-if="item == 5" class="left5">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText8.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText9.png"
                    />
                    <div class="rightText">
                      北斗院智慧轨道解决方案基于物联网、大数据、人工智能、三维地理信息等技术，深度挖掘各类轨道运营数据，覆盖运营管理、商业管理、安全管理、人员管理四大业务板块，构建轨道智能决策大脑。
                    </div>
                  </div>
                  <div v-if="item == 6" class="left6">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText10.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText11.png"
                    />
                    <div class="rightText">
                      基于民航局提出“平安、绿色、智慧、人文”为核心的“四型机场”建设目标，以智慧为牵引的发展战略，利用人工智能、大数据、物联网等新技术具有强大的赋能作用，通过搭建机场大数据平台、智能决策引擎、联合指挥平台等，构建一个全感知、全联接、全场景、全智能的数字化机场。
                    </div>
                  </div>
                  <div v-if="item == 7" class="left7">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText12.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText13.png"
                    />
                    <div class="rightText">
                      利用物联网、大数据、IT服务化平台等技术，结合业界的数字化转型领先实践经验，在物流领域开展物流对象过程数字化、资源规划智能化、流程可视化等方面的建设，构建多位一体全透明自动化物流体系，从生产到运输的全生命周期的流程可视，真正做到“人与物的高效沟通”。
                    </div>
                  </div>
                  <div v-if="item == 8" class="left8">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText14.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText15.png"
                    />
                    <div class="rightText">
                      公司致力于成为新型智慧城市解决方案领导者，充分运用最新的信息化技术，构建完整、可灵活扩展的智慧城市总体框架，秉承“平台+生态”的策略，打造新型智慧城市数字大脑，落地“1+1+N“的总体建设框架，提供支撑新型智慧城市建设的创新数字化解决方案和服务。
                    </div>
                  </div>

                  <div v-if="item == 9" class="left8">
                    <img
                      class="rightTitle1"
                      src="../../static/images/solutionText30.png"
                    />
                    <br />
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText31.png"
                    />
                    <div class="rightText">
                      智慧园区主要面向政府管理部门、园区管理方、园区企业、园区从业人员等，依托物联网、大数据、移动互联网、数字孪生等新一代信息技术，自主研发打造“一个中心、四个平台（产业营销平台、运营服务平台、便民服务平台、物联服务平台）”。解决方案满足园区信息化建设的需求...
                    </div>
                  </div>

                  <!--
                  <div v-if="item !=1" @click="goDetail" class="know">了解更多</div>
                  -->
                  <div v-if="item != 1">
                    <router-link
                      class="knowLink"
                      :to="{ path: 'SolutionDetail' + (item - 1) }"
                    >
                      <div class="know">了解更多</div>
                    </router-link>
                  </div>
                </div>
                <div class="right">
                  <div v-if="item == 1" class="right1">
                    <div class="rightTitle1">Industry Solutions</div>
                    <img
                      class="rightTitle2"
                      src="../../static/images/solutionText.png"
                    />
                    <div class="rightText">
                      北斗院深耕智能交通行业多年，打造了完整而先进的多种公共交通解决方案，包括智慧安防、智慧民航、智慧物流、智慧地铁、综合交通、智慧高速等，助推行业智能化升级与变革。
                    </div>
                    <div class="itemLayout">
                      <div class="selectItem" @click="changePic(1)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem1.png"
                        />
                        <div class="selectItemText">综合交通行业解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(2)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem2.png"
                        />
                        <div class="selectItemText">智慧高速解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(3)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem3.png"
                        />
                        <div class="selectItemText">智慧安防解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(4)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem4.png"
                        />
                        <div class="selectItemText">智慧轨道解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(5)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem5.png"
                        />
                        <div class="selectItemText">智慧机场解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(6)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem6.png"
                        />
                        <div class="selectItemText">智慧物流解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(7)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem7.png"
                        />
                        <div class="selectItemText">智慧城市解决方案</div>
                      </div>
                      <div class="selectItem" @click="changePic(8)">
                        <img
                          class="selectItemImg"
                          src="../../static/images/solutionItem8.png"
                        />
                        <div class="selectItemText">智慧园区解决方案</div>
                      </div>
                      <div class="selectItemAlter"></div>
                    </div>
                  </div>
                  <div v-if="item == 2" class="right2">
                    <img src="../../static/images/solutionPic2.png" />
                  </div>
                  <div v-if="item == 3" class="right3">
                    <img src="../../static/images/solutionPic3.png" />
                  </div>
                  <div v-if="item == 4" class="right4">
                    <img src="../../static/images/solutionPic4.png" />
                  </div>
                  <div v-if="item == 5" class="right5">
                    <img src="../../static/images/solutionPic5.png" />
                  </div>
                  <div v-if="item == 6" class="right6">
                    <img src="../../static/images/solutionPic6.png" />
                  </div>
                  <div v-if="item == 7" class="right7">
                    <img src="../../static/images/solutionPic7.png" />
                  </div>
                  <div v-if="item == 8" class="right8">
                    <img src="../../static/images/solutionPic8.png" />
                  </div>
                  <div v-if="item == 9" class="right8">
                    <img src="../../static/images/solutionPic9.png" class="right3Img"/>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </transition>
    <div class="copy-right">
      <div class="right">Copyright©2020-2030深圳北斗应用技术研究院有限公司,保留所有权利  <span style="cursor: pointer;" @click="toGov">{{ copyright }}</span></div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Index",
  data() {
    return {
      index: 0,
      height: 0,
      number: 0,
      copyright: '粤ICP备15028556号-2'
    };
  },
  computed:{
    pageIndex(){
      return this.$route.query.index||0;
    }
  },
  watch:{
    pageIndex(val){
      this.changePic(val);
    }
  },
  mounted: function () {
    //console.log(this.$route.query.item);
    this.number = this.$route.query.item;
    setTimeout(()=>{
      this.changePic(this.pageIndex);
    })
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
    window.addEventListener("mousewheel", this.handleScroll, false);
    if(window.location.host === 'openxdata.cn'){
      this.copyright = '粤ICP备15028556号-1';
    }else{
      this.copyright = '粤ICP备15028556号-2';
    }
  },
  methods: {
    toGov(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index');
    },
    goDetail: function () {
      this.$router.push({
        path: "solutionDetail",
      });
    },
    changePic: function (index) {
      this.$refs.changeCard.setActiveItem(index);
      this.index = index;
    },
    handleScroll(e) {
      var direction = e.deltaY > 0 ? "down" : "up"; //该语句可以用来判断滚轮是向上滑动还是向下
      //console.log("this.index", this.index);
      let that = this;
      setTimeout(() => {
        if (direction === "down") {
          that.$refs.changeCard.setActiveItem(that.index + 1);
          that.index = that.index + 1;
          if (that.index == 10) {
            that.index = 1;
          }
        } else {
          if (that.index == 1) {
            that.$refs.changeCard.setActiveItem(8);
            that.index = 8;
          } else {
            that.$refs.changeCard.setActiveItem(that.index - 1);
            that.index = that.index - 1;
          }
        }
      }, 10);
    },
  },
};
</script>
<style scoped>
@import "./Solution.css";
@import "./Foot.css";
</style>



// WEBPACK FOOTER //
// src/views/Solution.vue